import { ConditionalPartial } from '../../../../utils';
import { CreateComplaintsProcessConfigRequestDto } from './create-complaints-process-config.request.dto';

/**
 * DTO for updating complaints process configuration
 * All fields are optional for partial updates
 */
export class UpdateComplaintsProcessConfigRequestDto extends ConditionalPartial(
    CreateComplaintsProcessConfigRequestDto,
) {}
